import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import axiosInstance from "../api/axiosInstance";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function WaitingTimeChart() {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(false);

  useEffect(() => {
    axiosInstance.get("dashboard/waiting_stats")
      .then(res => {
        const rows = res.data?.data || [];
        if (!rows.length) { setHasData(false); setLoading(false); return; }

        const labels = rows.map(r => {
          const d = new Date(r.date);
          return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
        });

        setChartData({
          labels,
          datasets: [
            {
              label: "Avg Wait (min)",
              data: rows.map(r => r.avg_wait_minutes ?? 0),
              backgroundColor: "#fb8c00cc",
              borderColor: "#fb8c00",
              borderWidth: 1,
              borderRadius: 5,
            },
            {
              label: "Avg Service (min)",
              data: rows.map(r => r.avg_service_minutes ?? 0),
              backgroundColor: "#1e9690cc",
              borderColor: "#1e9690",
              borderWidth: 1,
              borderRadius: 5,
            },
          ],
        });
        setHasData(true);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 11 }, boxWidth: 12, padding: 10 },
      },
      tooltip: {
        callbacks: {
          label: ctx => ` ${ctx.dataset.label}: ${ctx.parsed.y} min`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 11 } },
      },
      y: {
        beginAtZero: true,
        grid: { color: "#f0f2f5" },
        ticks: {
          font: { size: 11 },
          callback: v => `${v}m`,
        },
      },
    },
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
        <div className="spinner-border spinner-border-sm" style={{ color: "#fb8c00" }} />
      </div>
    );
  }

  if (!hasData) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: 200, color: "#9aa0ac" }}>
        <i className="ti ti-clock-off" style={{ fontSize: 32, marginBottom: 8, opacity: 0.4 }} />
        <span style={{ fontSize: 13 }}>No waiting time data yet</span>
        <span style={{ fontSize: 11, marginTop: 4 }}>Data appears once patients are tracked via Arrived / Call buttons</span>
      </div>
    );
  }

  return (
    <div style={{ height: 220, padding: "0 8px 8px" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
}
